import { Component, Injector, OnInit } from '@angular/core';
import {
  AvailableShippingMethods,
  ShippingMethodEnum,
  ShippingMethodType,
  StepData
} from 'models';
import { debounceTime, first } from 'rxjs/operators';
import { ShippingMethodTypes } from '../../../constants/shipping.constants';
import { ProcessStepBaseComponent } from '../../_core/process-step-base.component';

@Component({
  selector: 'sb-step-shipping-method',
  templateUrl: './shipping-method.component.html',
  styleUrls: ['./shipping-method.component.scss']
})
export class ShippingMethodComponent extends ProcessStepBaseComponent implements OnInit {
  public availableShippingTypes: ShippingMethodType[] = [];
  private shippingTypes = ShippingMethodTypes;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    // super.shouldShowBackButton();
    super.isStickyNavigation();
    super.setFormGroup(this.formsService.generateStepShippingMethodForm());
    super.setFormStoreDataFunction(this.appStoreFacadeService.step.storeStepShippingValue);
    this.getFormDataAndValidation();
  }

  get isShippingMethodInvalid() {
    const paymentMethodGroup = this.formGroup.get('shippingMethod');
    return paymentMethodGroup.touched && paymentMethodGroup.invalid;
  }

  private getFormDataAndValidation() {
    this.subscriptions.add(
      this.appStoreFacadeService.entity.availableShippingMethods$
        .pipe(first(Boolean))
        .subscribe(({ methods }: AvailableShippingMethods) => {
          this.availableShippingTypes = this.shippingTypes.filter(type => {
            return methods.includes(type.id as ShippingMethodEnum);
          });

          // Set default
          if (!this.formGroup.value.shippingMethod.method) {
            this.formGroup.patchValue({ shippingMethod: { method: this.availableShippingTypes[0].id } });
          }
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.shipping$
        .subscribe((stepData: StepData) => {
          super.setFormGroupStepData(stepData);
        })
    );

    this.subscriptions.add(
      this.appStoreFacadeService.step.shippingValue$
        .pipe(debounceTime(150), first(Boolean))
        .subscribe(() => {
          this.sendAnalyticsData();
        })
    );
  }
}

